import { useState, useEffect } from "react";
import { getUserDetailsList } from "../../redux/getUserDetails/getUserDetailsSlice";

import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Box,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import MWLoader from "../../components/MWLoader";
import ResetPwd from "./ResetPwd";
import AddUserEmail from "./AddUserEmail";
import PageLayout from "../../components/PageLayout";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
// import { useTranslation } from "react-i18next";
// import { TFunction } from "i18next";

export default function UserProfile() {
  // const { t }: { t: TFunction & ((key: string) => string) } = useTranslation();
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUsername] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const loadingMarkup = isLoading ? <MWLoader /> : null;
  // Reset Password toggle
  const [isResetPwdOpen, setIsResetPwdOpen] = useState(false);
  const toggleResetPwd = () => setIsResetPwdOpen(!isResetPwdOpen);
  // Edit Email toggle
  const [isEditEmailOpen, setIsEditEmailOpen] = useState(false);
  const toggleEditEmail = () => setIsEditEmailOpen(!isEditEmailOpen);

  // Get userprofile API
  const getUserProfile = () => {
    dispatch(getUserDetailsList());
  };

  useEffect(() => {
    dispatch(getUserDetailsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUserDetailsListRes = useAppSelector(
    (state) => state.getUserDetailsList
  );
  useEffect(() => {
    getUserDetailsListRes?.loading ? setIsLoading(true) : setIsLoading(false);
  }, [getUserDetailsListRes]);

  useEffect(() => {
    if (
      getUserDetailsListRes?.patientDropdownListRes?.userDetails !== undefined
    ) {
      let userDetails =
        getUserDetailsListRes?.patientDropdownListRes.userDetails;
      setUsername(userDetails.username);
      setFirstName(userDetails.firstName);
      setLastName(userDetails.lastName);
      setEmail(userDetails.email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getUserDetailsListRes]);

  // Table Markup
  const userprofilePageMarkup = (
    <Card>
      <CardHeader
        action={
          <Box>
            <Button variant="outlined" sx={{ mr: 2 }} onClick={getUserProfile}>
              Reload
              {/* {t("userprofile.reload", { ns: "home" })!} */}
            </Button>
            <Button variant="outlined" onClick={toggleResetPwd}>
              Reset Password
              {/* {t("userprofile.resetpsword", { ns: "home" })!} */}
            </Button>
          </Box>
        }
      />
      <CardContent>
        <TableContainer>
          <Table>
            <TableBody>
              {[
                {
                  term: `User Name`, // `${t("userprofile.uname", { ns: "home" })}`,
                  description: userName,
                },
                {
                  term: `First Name`, //`${t("signup.fname", { ns: "home" })}`,
                  description: firstName,
                },
                {
                  term: `Last Name`, //`${t("signup.lname", { ns: "home" })}`,
                  description: lastName,
                },
                {
                  term: `Email`, //`${t("loginpage.emailorphno", { ns: "home" })}`,
                  description:
                    email === "" ? (
                      <Button onClick={toggleEditEmail}>
                        Add Email
                        {/* {t("userprofile.addemail", { ns: "home" })!} */}
                      </Button>
                    ) : (
                      email
                    ),
                },
              ].map((row) => (
                <TableRow key={row.term}>
                  <TableCell component="th" scope="row">
                    <strong>{row.term}</strong>
                  </TableCell>
                  <TableCell>{row.description}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
  return (
    <Box>
      {loadingMarkup}
      <PageLayout>
        <Typography variant="h5" sx={{ mb: 2 }}>
          <b>
            User Details
            {/* {t("userprofile.userdetails", { ns: "home" })!} */}
          </b>
        </Typography>
        <ResetPwd
          toggleResetPwd={toggleResetPwd}
          isResetPwdOpen={isResetPwdOpen}
        />
        <AddUserEmail
          toggleEditEmail={toggleEditEmail}
          isEditEmailOpen={isEditEmailOpen}
        />
        {userprofilePageMarkup}
      </PageLayout>
    </Box>
  );
}
